module.exports = __webpack_public_path__ + "img/result-detail-invest-inright02.667a11cd.svg";